import React from "react";
import AsyncSelect from "react-select/async";
import PropTypes from "prop-types";

// API & Models
import UsersApi from "../../Classes/API/UsersApi";
import searchUsersReq from "../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../Classes/Models/Requests/Users/UserTypes";
import MDTypography from "components/MDTypography";

const PatientSelector = ({
  value,
  onChange,
  placeholder = "Search Patient...",
  error = false,
}) => {
  const loadPatients = async (inputValue) => {
    let searchReq = new searchUsersReq();
    let types = new UserTypes();
    searchReq.name = inputValue;
    searchReq.userType = types.Patient;
    searchReq.pagingParams.pageSize = 20;

    try {
      let res = await UsersApi.SearchUsers(searchReq);
      if (res.status === "Success") {
        return res.data.list.map((item) => ({
          value: item, 
          label: item.name,
        }));
      }
    } catch (err) {
      console.error("Patient Search Error:", err);
    }
    return [];
  };

  return (
    <>
      <MDTypography
        variant="caption"
        fontWeight="bold"
        textTransform="uppercase"
        mb={1}
        display="block"
      >
        Patient
      </MDTypography>
      <AsyncSelect
        isClearable
        cacheOptions
        defaultOptions
        loadOptions={loadPatients}
        value={value ? { value: value, label: value.name } : null}
        onChange={(opt) => onChange(opt ? opt.value : null)}
        placeholder={placeholder}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "44px",
            borderRadius: "8px",
            borderColor: error ? "red" : base.borderColor,
          }),
          menu: (base) => ({ ...base, zIndex: 999 }),
        }}
      />
    </>
  );
};

PatientSelector.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
};

export default PatientSelector;
